import axios from "axios";
import { uploadTOS3BucketUrl } from "../../services/CourseService";

export const handleUploadToS3BucketUrl = async (files, fileListData) => {
  if (!files || files.length === 0) return;

  try {
    const formData = new FormData();
    formData.append("uploadFiles", JSON.stringify(files));

    const response = await uploadTOS3BucketUrl(formData);
    const uploadURLList = response.data?.data || [];

    if (!uploadURLList.length || uploadURLList.length !== files.length) {
      throw new Error("Mismatch in number of files and upload URLs");
    }

    const uploadedFileKeys = [];

    if ((Array.isArray(fileListData) && fileListData.length > 0) || (typeof fileListData === 'object' && fileListData !== null && fileListData?.length > 1)) {
      // const filesData = fileListData.map(item => item.file);

      for (let i = 0; i < fileListData.length; i++) {
        const file = fileListData[i];
        const uploadURL = uploadURLList[i]?.uploadURL;
        const fileKey = uploadURLList[i]?.fileKey;

        if (!file || !uploadURL) continue;

        const uploadResponse = await axios.put(uploadURL, file, {
          headers: {
            "Content-Type": file.type,
          },
        });

        if (uploadResponse.status === 200) {
          uploadedFileKeys.push({
            path: fileKey,
            size: file.size,
            absolutePath: uploadURL
          });
        } else {
          throw new Error(`Upload failed for ${file.name} with status ${uploadResponse.status}`);
        }
      }
    } else {
      // Single file fallback
      const uploadURL = uploadURLList[0]?.uploadURL;
      const fileKey = uploadURLList[0]?.fileKey;

      const uploadResponse = await axios.put(uploadURL, fileListData, {
        headers: {
          "Content-Type": fileListData?.type,
        },
      });

      if (uploadResponse.status === 200) {
        uploadedFileKeys.push({
          path: fileKey,
          size: fileListData?.size,
          absolutePath: uploadURL
        });
      } else {
        throw new Error(`S3 upload failed with status: ${uploadResponse.status}`);
      }
    }

    return uploadedFileKeys;
  } catch (error) {
    console.error("Error in file upload:", error);
    throw error;
  }
};



